{
  "defaultTitle": "Nie można się zameldować",
  "defaultMessage": "Proszę potwierdzić informacje z dyspozytorem lub skontaktować się z magazynem",
  "backToHomescreen": "Powrót do ekranu głównego",
  "hideErrorLog": "UKRYJ DZIENNIK BŁĘDÓW",
  "viewErrorLog": "POKAŻ DZIENNIK BŁĘDÓW",
  "errorLogMessageLabel": "Wiadomość:",
  "errorLogStatusLabel": "Kod statusu:",
  "unknown": "Nieznany"
}
